import { EventBus } from '@/event-bus';
import { generic_storage } from '../_utilities/generic_storage';
import { appointmentsService } from '../_services';

const extendedAppointmentsStore = generic_storage('appointmentsService');

extendedAppointmentsStore.state = {
  ...extendedAppointmentsStore.state,
  activity: {},
  chat: [],
  chatLoading: false,
  videoLoading: false,
  videoDownloadURL: null,
  videoThumbnailLoading: false,
  videoThumbnailURL: null,
};

extendedAppointmentsStore.actions = {
  ...extendedAppointmentsStore.actions,
  getActivity({ commit }, appointmentId) {
    commit('setIsLoading', true);
    return appointmentsService.getActivity(appointmentId).then((response) => {
      commit('setActivity', response.data);
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  createInvites({ commit }, payload) {
    commit('setIsLoading', true);
    return appointmentsService.createInvites(payload)
      .then((response) => response)
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  updateAppointment({ commit }, { id, payload }) {
    commit('setIsLoading', true);
    return appointmentsService.patchItem(id, payload)
      .then((response) => {
        // eslint-disable-next-line
        if (response.data.hasOwnProperty('products_repr')) {
          response.data.products = response.data.products_repr;
          // delete products_repr if possible (later)
        }
        commit('updateItem', response.data);
        return response;
      })
      .catch(() => {
        EventBus.$emit('toast-error', 'An error occurred while updating the appointment, please try again later.');
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  updateInvites({ commit }, {
    id, inviteesPayload, groupPayload, notify, authCode,
  }) {
    commit('setIsLoading', true);
    return appointmentsService.patchInvites(id, inviteesPayload, groupPayload, notify, authCode)
      .then((response) => response)
      .catch(() => {
        EventBus.$emit('toast-error', 'An error occurred while updating the appointment, please try again later.');
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  resendInvitations({ commit }, { id, authCode }) {
    commit('setIsLoading', true);
    return appointmentsService.resendInvitations(id, authCode)
      .then((response) => {
        EventBus.$emit('toast-success', 'Invitations re-sent successfully!');
        return response;
      })
      .catch(() => {
        EventBus.$emit('toast-error', 'Couldn\'t resend invitations, please try again later.');
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  downloadICS({ commit }, id) {
    commit('setIsLoading', true);
    return appointmentsService.downloadICS(id)
      .then((response) => response)
      .catch(() => {
        EventBus.$emit('toast-error', 'An error occurred while trying to download this file, please try again later.');
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  getReportItem({ commit }, appointmentId) {
    commit('setIsLoading', true);
    return appointmentsService.getReportItem(appointmentId).then((response) => {
      commit('updateItem', response.data);
    }).catch(() => {
      EventBus.$emit('toast-error',
        'There\'s been a problem while fetching appointment data, please try again in a few moments.');
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  getChat({ commit }, appointmentId) {
    commit('setChatLoading', true);
    return appointmentsService.getChat(appointmentId).then((response) => {
      commit('updateChat', response.data);
    }).catch((error) => {
      console.log('Could not retrieve chat:', error);
    }).finally(() => {
      commit('setChatLoading', false);
    });
  },
  getVideoDownloadURL({ commit }, appointmentId) {
    commit('setVideoLoading', true);
    appointmentsService.getVideoDownloadURL(appointmentId).then((response) => {
      commit('setVideoLoading', false);
      commit('setVideoDownloadURL', response.data.url);
    });
  },
  getVideoThumbnailURL({ commit }, appointmentId) {
    commit('setVideoThumbnailLoading', true);
    appointmentsService.getVideoThumbnailURL(appointmentId).then((response) => {
      commit('setVideoThumbnailLoading', false);
      commit('setVideoThumbnailURL', response.data.url);
    });
  },
};

extendedAppointmentsStore.mutations = {
  ...extendedAppointmentsStore.mutations,
  setActivity(state, data) {
    state.activity = data;
  },
  updateChat(state, chat) {
    state.chat = chat;
  },
  setChatLoading(state, isLoading) {
    state.chatLoading = isLoading;
  },
  setVideoLoading(state, isLoading) {
    state.videoLoading = isLoading;
  },
  setVideoDownloadURL(state, url) {
    state.videoDownloadURL = url;
  },
  setVideoThumbnailLoading(state, isLoading) {
    state.videoThumbnailLoading = isLoading;
  },
  setVideoThumbnailURL(state, url) {
    state.videoThumbnailURL = url;
  },
};

export const appointments = extendedAppointmentsStore;
